<template>
  <div class="wrapper" v-if="fiveTypeFlag && homeworkList.length > 0">
    <div class="head">
      <div class="titleLeft" @click="returnTopic">
        <img src="../../assets/images/titleArrow.png" />
        <div class="label">{{ this.$route.query.label }}</div>
      </div>
      <!--  -->
      <div class="titleRight">
        <img
          v-if="this.$route.query.name == 'topic'"
          src="../../assets/images/knowledge.png"
          @click="knowledgeClick()"
          alt=""
        />
        <img
          v-if="this.$route.query.name == 'topic'"
          src="../../assets/images/correctIcon.png"
          alt=""
          @click="errorCorrectionClick()"
        />
        <img
          v-if="
            this.$route.query.name == 'topic' ||
            this.$route.query.name == 'note'
          "
          src="../../assets/images/noteIcon.png"
          alt=""
          @click="noteClick()"
        />
        <div v-if="this.$route.query.name == 'topic'">
          <img
            v-if="homeworkList[0].isFavorite == 0"
            src="../../assets/images/collectIcon.png"
            alt=""
            @click="handleImageClick()"
          />
          <img
            v-if="homeworkList[0].isFavorite == 1"
            src="../../assets/images/cancelCollectIcon.png"
            alt=""
            @click="handleImageClick()"
          />
        </div>
        <img
          v-if="
            this.$route.query.name == 'topic' ||
            this.$route.query.name == 'errorCorrection' ||
            this.$route.query.name == 'groupQuestion' ||
            this.$route.query.name == 'testCreation'
          "
          src="../../assets/images/cardIcon.png"
          alt=""
          @click="cardUpClick()"
        />
        <img
          v-if="
            this.$route.query.name == 'topic' ||
            this.$route.query.name == 'groupQuestion' ||
            this.$route.query.name == 'testCreation'
          "
          src="../../assets/images/setUpIcon.png"
          alt=""
          @click="setUpClick"
          style="z-index: 9999"
        />
      </div>
    </div>

    <div id="contain" ref="containRef" @click="closeSetUp">
      <ul
        class="homework"
        ref="homeworkRef"
        v-if="setUpType === 1"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
      >
        <li v-for="(item, index) in homeworkList" :key="index" class="homeLi">
          <div class="homework-main" :class="{ active: item.type == 8 }">
            <div>
              <span class="title" :style="{ fontSize: oneSize + 'px' }"
                >【{{ filterType(item.type) }}】</span
              >
            </div>
            <div
              class="publicContent"
              v-if="item.publicContent"
              :style="{ fontSize: twoSize + 'px' }"
            >
              {{ item.publicContent }}
            </div>
            <ul class="publicSelect" v-if="item.type == 4">
              <li
                v-for="(itm, idx) in item.selectList"
                :key="idx"
                :style="{ fontSize: twoSize + 'px' }"
              >
                <span>{{ itm.type }}.</span>{{ itm.name }}
              </li>
            </ul>
            <div class="content" :style="{ fontSize: threeSize + 'px' }">
              {{ topicIndex + 1 }}.{{ item.content }}
            </div>
            <div class="file">
              <div class="imgBox" v-if="isImgFile(item.fileUrl)">
                <img :src="imgUrl + item.fileUrl" alt="" />
              </div>
              <div class="videoBox" v-if="isVideoFile(item.fileUrl)">
                <video
                  :src="imgUrl + item.fileUrl"
                  width="300"
                  height="200"
                  controls
                ></video>
              </div>
              <template>
                <div class="audioBox" v-if="isAudioFile(item.fileUrl)">
                  <audio
                    v-show="false"
                    :src="imgUrl + item.fileUrl"
                    controls
                    ref="audioPlayer"
                    @loadedmetadata="setDuration"
                    @timeupdate="updateCurrentTime"
                    @ended="onAudioEnded"
                  ></audio>
                  <div class="audioBox">
                    <div class="progressBar">
                      <span>{{ formatTime(currentTime) }}</span>
                      <input
                        @input="onSliderChange"
                        @touchstart.stop
                        @touchend.stop
                        type="range"
                        min="0"
                        :max="Math.round(duration)"
                        v-model="currentTime"
                        :style="progressStyle"
                      />
                      <span>{{ formatTime(duration) }}</span>
                    </div>
                    <div class="operateBox">
                      <div class="wave"></div>
                      <div
                        class="pause"
                        v-if="!isPlaying"
                        @click="togglePlay"
                      ></div>
                      <div class="play" v-else @click="togglePlay"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <ul class="select">
              <li v-for="(itm, idx) in item.selectList" :key="idx">
                <span
                  v-if="item.result"
                  :class="bindClass(itm.type, item.correct, item.result)"
                  >{{ itm.type }}</span
                >
                <span
                  v-else
                  @click="handleSelect(item, itm, index)"
                  :class="{ selected: itm.selected && item.type == 5 }"
                  >{{ itm.type }}</span
                >
                <div :style="{ fontSize: threeSize + 'px' }">
                  {{ item.type == 4 ? itm.type : itm.name }}
                </div>
              </li>
            </ul>
            <textarea
              class="askInput"
              v-if="item.type == 8 && !item.result"
              v-model="texthtml"
              :style="{ fontSize: threeSize + 'px' }"
            ></textarea>
            <div class="haveResult" v-if="item.type == 8 && item.result">
              {{ item.result }}
            </div>
            <ul class="blanksUl" v-if="item.type == 7">
              <li v-for="(v, i) in item.blanksList" :key="i">
                <textarea
                  :style="{ fontSize: threeSize + 'px' }"
                  v-model="v.name"
                  :placeholder="i + 1 + '.请输入内容'"
                  @input="autoBlanksTextarea($event.target)"
                  :readonly="item.result"
                ></textarea>
              </li>
            </ul>
            <div class="correctAnswerBox" v-if="item.result">
              <div
                class="correctAnswer"
                v-if="item.type == 7 || item.type == 8"
                :style="{ fontSize: threeSize + 'px' }"
              >
                <span></span>正确答案
              </div>
              <div
                class="selectAnswer"
                v-else
                :style="{ fontSize: twoSize + 'px' }"
              >
                正确答案是"<span>{{ item.correct }}</span
                >",您的答案是"<span>{{ item.result }}</span
                >"
              </div>
              <ul class="correctAnswerUl" v-if="item.type == 7">
                <li
                  v-for="(v, i) in item.correctList"
                  :key="i"
                  class="correctAnswerLi"
                >
                  第{{ i + 1 }}空： {{ v }}
                </li>
              </ul>
              <div
                class="correct"
                v-if="item.type == 8"
                :style="{ fontSize: twoSize + 'px' }"
              >
                {{ item.correct }}
              </div>
              <div
                v-if="item.analysis"
                class="correctAnswer"
                :style="{ fontSize: threeSize + 'px' }"
              >
                <span></span>试题详解
              </div>
              <div
                v-if="item.analysis"
                class="correct"
                :style="{ fontSize: twoSize + 'px' }"
              >
                {{ item.analysis }}
              </div>
            </div>
          </div>
          <!-- <div>{{ item.correct }}</div> -->

          <div
            class="bottom"
            v-if="
              (item.type == 7 || item.type == 8 || item.type == 5) &&
              !item.result
            "
          >
            <div class="btn" @click="submit(item, index)">提交答案</div>
          </div>
          <!-- <div class="upwardBtn" @click="upwardClick()">上一题</div>
          <div class="downBtn" @click="downClick()">下一题</div> -->
        </li>
      </ul>

      <ul
        class="homework"
        ref="homeworkRef"
        v-if="setUpType === 2"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
      >
        <li v-for="(item, index) in homeworkList" :key="index" class="homeLi">
          <div class="homework-main" :class="{ active: item.type == 8 }">
            <div>
              <span class="title" :style="{ fontSize: oneSize + 'px' }"
                >【{{ filterType(item.type) }}】</span
              >
            </div>
            <div
              class="publicContent"
              v-if="item.publicContent"
              :style="{ fontSize: twoSize + 'px' }"
            >
              {{ item.publicContent }}
            </div>
            <ul class="publicSelect" v-if="item.type == 4">
              <li
                v-for="(itm, idx) in item.selectList"
                :key="idx"
                :style="{ fontSize: twoSize + 'px' }"
              >
                <span>{{ itm.type }}.</span>{{ itm.name }}
              </li>
            </ul>
            <div class="content" :style="{ fontSize: threeSize + 'px' }">
              {{ topicIndex + 1 }}.{{ item.content }}
            </div>
            <div class="file">
              <div class="imgBox" v-if="isImgFile(item.fileUrl)">
                <img :src="imgUrl + item.fileUrl" alt="" />
              </div>
              <div class="videoBox" v-if="isVideoFile(item.fileUrl)">
                <video
                  :src="imgUrl + item.fileUrl"
                  width="300"
                  height="200"
                  controls
                ></video>
              </div>
              <template>
                <div class="audioBox" v-if="isAudioFile(item.fileUrl)">
                  <audio
                    v-show="false"
                    :src="imgUrl + item.fileUrl"
                    controls
                    ref="audioPlayer"
                    @loadedmetadata="setDuration"
                    @timeupdate="updateCurrentTime"
                    @ended="onAudioEnded"
                  ></audio>
                  <div class="audioBox">
                    <div class="progressBar">
                      <span>{{ formatTime(currentTime) }}</span>
                      <input
                        @input="onSliderChange"
                        @touchstart.stop
                        @touchend.stop
                        type="range"
                        min="0"
                        :max="Math.round(duration)"
                        v-model="currentTime"
                        :style="progressStyle"
                      />
                      <span>{{ formatTime(duration) }}</span>
                    </div>
                    <div class="operateBox">
                      <div class="wave"></div>
                      <div
                        class="pause"
                        v-if="!isPlaying"
                        @click="togglePlay"
                      ></div>
                      <div class="play" v-else @click="togglePlay"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <ul class="select">
              <li v-for="(itm, idx) in item.selectList" :key="idx">
                <span
                  :class="bindClass(itm.type, item.correct, item.correct)"
                  >{{ itm.type }}</span
                >

                <div :style="{ fontSize: threeSize + 'px' }">
                  {{ item.type == 4 ? itm.type : itm.name }}
                </div>
              </li>
            </ul>
            <textarea
              class="askInput"
              v-if="item.type == 8 && !item.result"
              v-model="texthtml"
              :readonly="true"
              :style="{ fontSize: threeSize + 'px' }"
            ></textarea>
            <ul class="blanksUl" v-if="item.type == 7">
              <li v-for="(v, i) in item.correct.split('[$]')" :key="i">
                <textarea
                  :style="{ fontSize: threeSize + 'px' }"
                  :placeholder="i + 1 + '.请输入内容'"
                  :readonly="true"
                ></textarea>
              </li>
            </ul>
            <div class="correctAnswerBox">
              <div
                class="correctAnswer"
                v-if="item.type == 7 || item.type == 8"
                :style="{ fontSize: threeSize + 'px' }"
              >
                <span></span>正确答案
              </div>
              <div
                class="selectAnswer"
                v-else
                :style="{ fontSize: twoSize + 'px' }"
              >
                正确答案是"<span>{{ item.correct }}</span
                >"
              </div>
              <ul class="correctAnswerUl" v-if="item.type == 7">
                <li
                  v-for="(v, i) in item.correctList"
                  :key="i"
                  class="correctAnswerLi"
                  :style="{ fontSize: threeSize + 'px' }"
                >
                  第{{ i + 1 }}空： {{ v }}
                </li>
              </ul>
              <div
                class="correct"
                v-if="item.type == 8"
                :style="{ fontSize: twoSize + 'px' }"
              >
                {{ item.correct }}
              </div>
              <div
                v-if="item.analysis"
                class="correctAnswer"
                :style="{ fontSize: threeSize + 'px' }"
              >
                <span></span>试题详解
              </div>
              <div
                v-if="item.analysis"
                class="correct"
                :style="{ fontSize: threeSize + 'px' }"
              >
                {{ item.analysis }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <!-- <div class="cardBox" v-if="cardFlag"> -->
      <van-popup v-model="cardFlag" position="bottom" round class="card">
        <div class="cardTitle">答题卡</div>
        <ul
          :class="[nameType == 'errorCorrection' ? 'errorCorrectionStyle' : '']"
          class="cardUl"
        >
          <li
            v-for="(item, index) in answerSheetList"
            :key="index"
            @click="cardLiClick(item, index)"
            :class="bindResult(item.isRight, item, index)"
          >
            {{ index + 1 }}
          </li>
        </ul>
        <div v-if="this.$route.query.name == 'topic'" class="bottom">
          <div class="btn" @click="clearAnswerCard">清除答题记录</div>
        </div>
      </van-popup>
    </div>
    <!-- 设置 -->
    <div class="setUpBox" v-if="setUpFlag">
      <div class="setUpType" @click="setUpTypeClick">
        <div :class="{ active: setUpType === 1 }">答题</div>
        <div :class="{ active: setUpType === 2 }">背题</div>
      </div>
      <div class="setUpFont">
        <span
          v-for="(item, index) in fontList"
          :key="index"
          :class="{ active: fontActive == index }"
          @click="fontClick(index)"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <!-- 收藏 -->
    <div class="collect" v-if="collectType == 1">已收藏</div>
    <div class="cancelCollect" v-if="collectType == 0">取消收藏</div>
    <!-- 笔记 -->
    <div class="cancelCollect" v-if="noteType">保存成功</div>
    <van-popup v-model="noteFlag" position="bottom" round class="noteBox">
      <h2>我的笔记</h2>
      <van-field
        v-if="this.$route.query.name == 'note'"
        class="noteTextarea"
        v-model="this.$route.query.noteContent"
        rows="13"
        readonly
        type="textarea"
        maxlength="1000"
        placeholder="请输入详细的描述，编辑老师将会在第一时间修正该错误。"
      />
      <van-field
        v-if="this.$route.query.name == 'topic'"
        class="noteTextarea"
        v-model="homeworkList[0].mark"
        autosize
        rows="13"
        type="textarea"
        maxlength="1000"
        placeholder="请输入详细的描述，编辑老师将会在第一时间修正该错误。"
      />
      <div class="noteBtnBox" v-if="this.$route.query.name == 'topic'">
        <div class="noteBtn" @click="noteSave">保存</div>
      </div>
    </van-popup>
    <!--纠错弹窗-->
    <van-popup v-model="showErrorPopup" position="bottom" round class="noteBox">
      <h2>纠错</h2>
      <div class="errorCon">
        <div class="top">
          <p
            :class="[
              questionErrorType == item.value ? 'activeType' : '',
              'type',
            ]"
            v-for="item in typeErrorOptions"
            @click="questionErrorType = item.value"
          >
            {{ item.label }}
          </p>
        </div>
        <div class="errorValue">
          <van-field
            v-model="errorDescription"
            rows="10"
            autosize
            type="textarea"
            placeholder="优质纠错内容被采纳，我们会联系你进行奖励。"
          />
          <div class="imgCon">
            <div class="imgContent" v-if="fileList.length > 0">
              <div class="pos" v-for="(item, index) in fileList">
                <img :src="imgUrl + item" class="sizeImg" />
                <van-icon
                  class="delImg"
                  name="cross"
                  color="#ff0000"
                  size="20"
                  @click="delImg(index)"
                />
              </div>
            </div>
            <div v-if="isWexin">
              <div class="photo" @click="uploadWeXin">
                <van-icon
                  class="photo-o"
                  name="photo-o"
                  color="#666666"
                  size="40"
                />
              </div>
            </div>
            <div v-else>
              <van-uploader :after-read="afterRead" v-if="!isAndroid" />
              <div class="photo" v-else @click="uploadAndroid">
                <van-icon
                  class="photo-o"
                  name="photo-o"
                  color="#666666"
                  size="40"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="btn" @click="commitError">提交</div>
      </div>
    </van-popup>
  </div>
  <div v-else-if="showNotBox" class="notBox">
    <div class="loadingCircle">
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="circle"></div>
      <img class="loading" src="../../assets/images/loadingImg.gif" alt="" />
    </div>
    <span>正在努力为你组题，请耐心等待...</span>
  </div>
</template>

<script>
import {
  studyRecordRenew,
  getQuestions,
  addQuestion,
  addQuestionResource,
  getQuestionsQuestionId,
  getOneQuestionId,
  getQuestionsList,
  studyPaperGetById,
  addQuestionResult,
  answerSheet,
  combinationAnswerSheet,
  wrongAnswerSheett,
  getWrongAnswerQuestions,
  resourceAnswerSheet,
  questionFeedBackErrorAdd,
} from "@/api/subject/index.js";
import { getDicts } from "@/api/system/dict/data";
import BScroll from "better-scroll";
import { ContactEdit, Toast, Dialog } from "vant";
import { uploadImg } from "@/api/system/config";
import ImagePreview from "@/components/ImagePreview";
import wx from "weixin-js-sdk";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  components: { ImagePreview },
  computed: {
    showNotBox() {
      return (
        this.$route.query.name === "groupQuestion" ||
        this.$route.query.name === "testCreation"
      );
    },
    currentQuestion() {
      // 返回当前题目，使用 currentPage 索引
      return this.homeworkList[this.currentPage] || {}; // 修改为 tempQuestions
    },
    progressStyle() {
      const percentage = this.duration
        ? (this.currentTime / this.duration) * 100
        : 0;
      console.log("percentage", percentage);
      return {
        background: `linear-gradient(to right, #1bbf8d ${percentage}%, #f2f8f5 ${percentage}%)`,
      };
    },
  },
  created() {
    this.studyBankId = this.$route.query.studyBankId;
    this.skillIntegral = Number(this.$route.query.skillIntegral);
    this.skillId = this.$route.query.skillId;
    this.skillName = this.$route.query.skillName;
    this.productInfoId = this.$route.query.productInfoId;
    this.majorType = this.$route.query.majorType;
    this.getDict();
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWexin = true;
      this.getApp();
    }
  },
  async mounted() {
    window.getU3dParams = this.getU3dParams;
    window.buyFirstStaionActionBack = this.buyFirstStaionActionBack;
    // // 在组件挂载时加载音频元数据
    const audio = this.$refs.audioPlayer;
    if (audio) {
      audio.load(); // 手动加载音频文件
    }
    // 刷题
    if (this.$route.query.name == "topic") {
      console.log("this.$route.query.isUnlock", this.$route.query.isUnlock);
      this.loadingToast = Toast.loading({
        message: "加载中",
        duration: 0, // 将duration设置为0，使Toast一直显示，直到手动关闭
        forbidClick: true,
      });
      await this.getAnswerSheet();
      this.$nextTick(() => {
        // 数据加载完成后关闭Toast
        this.loadingToast.clear();
      });
    }
    // 错题
    else if (this.$route.query.name == "errorCorrection") {
      console.log("错题");
      this.loadingToast = Toast.loading({
        message: "加载中",
        duration: 0, // 将duration设置为0，使Toast一直显示，直到手动关闭
        forbidClick: true,
      });
      await this.getAnswerSheet();
      // 数据加载完成后关闭Toast
      this.loadingToast.clear();
    }
    // 收藏
    else if (this.$route.query.name == "collect") {
      this.loadingToast = Toast.loading({
        message: "加载中",
        duration: 0, // 将duration设置为0，使Toast一直显示，直到手动关闭
        forbidClick: true,
      });
      // await this.getAnswerSheet();
      await this.getResourceAnswerSheet();
      // 数据加载完成后关闭Toast
      this.loadingToast.clear();
    }
    // 笔记
    else if (this.$route.query.name == "note") {
      this.loadingToast = Toast.loading({
        message: "加载中",
        duration: 0, // 将duration设置为0，使Toast一直显示，直到手动关闭
        forbidClick: true,
      });
      await this.getOneQuestionIdList(
        this.$route.query.majorType,
        this.$route.query.questionId
      );
      // 数据加载完成后关闭Toast
      this.loadingToast.clear();
    }
    // 智能组题
    else if (this.$route.query.name == "groupQuestion") {
      this.fiveTypeFlag = false;
      this.getCombinationAnswerSheet();
    }
    // 智能组题记录
    else {
      this.fiveTypeFlag = false;
      this.getCombinationAnswerSheet();
    }
  },
  data() {
    return {
      nameType: "",
      // 答题卡
      answerSheetList: [],
      // 截取数组
      interceptList: [],
      // 题目滑动方向
      direction: "",
      // 题目下标
      topicIndex: 0,
      // 全局滑动状态
      isRequesting: false,
      fiveTypeFlag: true,
      fieldStyle: { border: "1px solid #f5f5f5" /* 初始化边框颜色为灰色 */ },
      scroll: null,
      homeworkList: [],
      aloneList: [],
      typeData: [],
      cardBoxFlag: false,
      cardFlag: false,
      isTextareaReadOnly: false,
      texthtml: "", // 将 texthtml 改为数组，每个元素对应一个题目的答案
      // ---2
      categoryId: "",
      studyBankId: "",
      currentPage: 0,
      // 笔记
      noteType: false,
      noteFlag: false,
      notehtml: "",
      // 收藏
      collectFlag: 0,
      collectType: 3,
      debounceTimeout: null,
      // 设置
      setUpFlag: false,
      setUpType: 1,
      typeFlag: 0,
      fontActive: 1,
      oneSize: 12,
      twoSize: 14,
      threeSize: 16,
      fontList: [
        {
          name: "Aa",
        },
        {
          name: "Aa",
        },
        {
          name: "Aa",
        },
      ],
      // allQuestions: [], // 全量数据区
      // tempQuestions: [], // 暂存区，初始显示的数据
      // chunkSize: 100, // 每片数据的大小
      // currentChunkIndex: 0, // 当前显示的数据片索引
      duration: 0, // 假设总时长 60 秒（可换成动态数据）
      currentTime: 0, // 当前播放时间
      isPlaying: false, // 是否正在播放
      percentage: 0, // 新增 percentage 数据
      tabFlag: 0,
      skillIntegral: "",
      skillId: "",
      skillName: "",
      productInfoId: "",
      majorType: "",
      showErrorPopup: false, //纠错弹窗
      typeErrorOptions: [
        { label: "题目有误", value: "0" },
        { label: "答案有误", value: "1" },
        { label: "解析有误", value: "2" },
        { label: "其它有误", value: "3" },
      ],
      questionErrorType: "0",
      errorDescription: "",
      fileList: [],
      isWexin: false,
      isAndroid: false,
    };
  },
  watch: {
    // // 监听 fileUrl 变化，获取音频时长
    // "item.fileUrl": {
    //   handler(newVal) {
    //     if (this.isAudioFile(newVal)) {
    //       this.loadAudioDuration();
    //     }
    //   },
    //   immediate: true, // 组件加载时立即执行
    // },
  },
  create(){
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWexin = true
      this.getApp();
    }
  },
  methods: {
      //     Toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      clearAnswerCard() {
        Dialog.confirm({
          message: "是否清空答题记录 ? ",
        })
          .then(() => {
            const setList = {
              categoryId: this.$route.query.categoryId,
              majorType: this.majorType,
            };
            studyRecordRenew(setList).then((res) => {
              this.cardFlag = false;
              this.cardUpClick();
            });
          })
          .catch(() => {
            // on cancel
          });
      },
      judgeClient() {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
        console.log("是否是Android：" + isAndroid); //true,false
        console.log("是否是iOS：" + isIOS);
        if (isAndroid) {
          return "Android";
        } else if (isIOS) {
          return "IOS";
        } else {
          return "PC";
        }
      },
      androidIos() {
        if (this.judgeClient() == "Android") {
          this.callAndroidFunctionWithParameter();
        } else {
          // window.getU3dParams = this.getU3dParams;
          this.getAppParams();
          // this.buyFirstStaionActionBack();
        }
      },
      callAndroidFunctionWithParameter() {
        // this.$bridge.android.errorCorrection(
        //   JSON.stringify({
        //     // 给安卓传参
        //     bank: this.homeworkList[this.currentPage].bank,
        //     questionId: this.homeworkList[this.currentPage].id,
        //   })
        // );
        const that = this;

        if (this.tabFlag == 0) {
          // if (this.$route.query.isUnlock === "true") {
          this.$bridge.callmethod(
            "WebAction.questionsAction",
            // "123"
            JSON.stringify({
              // 给安卓传参
              skipUrl: Number(this.$route.query.code),
            })
          );
          // } else {
          //   this.$bridge.callmethod(
          //     "WebAction.buyFirstStaionAction",
          //     JSON.stringify({
          //       // 给安卓传参
          //       skillId: this.skillId,
          //       skillName: this.skillName,
          //       skillIntegral: this.skillIntegral,
          //       productInfoId: this.productInfoId,
          //     })
          //   );
          //   this.$bridge.registermethod("buyFirstStaionActionBack", () => {
          //     this.$nextTick(() => {
          //       this.$route.query.isUnlock = "true";
          //     });
          //   });
          // }
        } else {
          this.$bridge.callmethod(
            "WebAction.errorCorrection",
            // "123"
            JSON.stringify({
              // 给安卓传参
              bank: this.homeworkList[this.currentPage].bank + "",
              questionId: this.homeworkList[this.currentPage].id,
            })
          );
        }
      },
      getAppParams() {
        try {
          //使用此方法,会报错,因此使用try-catch
          if (this.tabFlag == 0) {
            // if (this.$route.query.isUnlock === "true") {
            webkit.messageHandlers.questionsAction.postMessage(
              JSON.stringify({
                skipUrl: Number(this.$route.query.code),
              })
            );
            // } else {
            //   webkit.messageHandlers.buyFirstStaionAction.postMessage(
            //     JSON.stringify({
            //       skillId: this.skillId,
            //       skillName: this.skillName,
            //       skillIntegral: this.skillIntegral,
            //       productInfoId: this.productInfoId,
            //     })
            //   );
            // }
          } else {
            webkit.messageHandlers.errorCorrection.postMessage(
              JSON.stringify({
                bank: this.homeworkList[this.currentPage].bank + "",
                questionId: this.homeworkList[this.currentPage].id,
              })
            );
          }
        } catch (error) {
          console.log("WKWebView post message error: ", error);
        }
      },
      buyFirstStaionActionBack() {
        this.$nextTick(() => {
          // this.$route.query.isUnlock = "true";
        });
      },
      autoBlanksTextarea(textarea) {
        console.log("textarea", textarea);
        textarea.style.height = "auto"; // 设置高度为自动以重新计算高度
        textarea.style.height = "40px"; // 默认设置为初始高度
        if (textarea.scrollHeight > 40) {
          textarea.style.height = textarea.scrollHeight + "px"; // 设置高度为文本内容的高度
        }
        if (textarea.value.trim() === "") {
          textarea.style.height = "40px"; // 如果内容为空，将高度设置为初始高度
        }
      },
      disableScroll() {
        this.$nextTick(() => {
          // 禁用BetterScroll滚动
          this.scroll && this.scroll.disable();
        });
      },
      enableScroll() {
        this.$nextTick(() => {
          // 启用BetterScroll滚动
          this.scroll && this.scroll.enable();
        });
      },
      returnTopic() {
        // console.log('this.$route.query.name',this.$route.query.name)
        if (this.$route.query.name == "errorCorrection") {
          this.$router.push({
            path: "/subjectErrorCorrection",
            query: {
              studyBankId: this.$route.query.studyBankId,
              categoryIds: this.$route.query.categoryIds,
              type: 1,
              majorType: this.$route.query.majorType,
            },
          });
        } else if (this.$route.query.name == "collect") {
          this.$router.push({
            path: "/subjectCollect",
            query: {
              studyBankId: this.$route.query.studyBankId,
              categoryIds: this.$route.query.categoryIds,
              type: 0,
              majorType: this.$route.query.majorType,
            },
          });
        } else if (this.$route.query.name == "note") {
          this.$router.push({
            path: "/subjectNote",
            query: {
              questionId: this.$route.query.questionId,
              majorType: this.$route.query.majorType,
              type: 0,
              majorType: this.$route.query.majorType,
            },
          });
        } else if (this.$route.query.name == "testCreation") {
          this.$router.push({
            path: "/subjectTestCreation",
            query: {
              studyBankId: this.$route.query.studyBankId,
              majorType: this.$route.query.majorType,
            },
          });
        } else if (this.$route.query.name == "groupQuestion") {
          this.$router.push({
            path: "/subjectGroupQuestion",
            query: {
              studyBankId: this.$route.query.studyBankId,
              majorType: this.$route.query.majorType,
            },
          });
        } else {
          this.$router.push({
            path: "/subject",
            query: {
              majorType: this.$route.query.majorType,
            },
          });
        }
      },
      // 答题卡
      async cardUpClick() {
        this.setUpFlag = false;
        if (!this.cardFlag) {
          this.cardFlag = !this.cardFlag;
          this.cardBoxFlag = this.cardFlag;
          this.scroll && this.scroll.disable();
          if (
            this.$route.query.name == "topic" ||
            this.$route.query.name == "errorCorrection"
          ) {
            this.getAnswerSheet();
          } else if (this.$route.query.name == "collect") {
            this.getResourceAnswerSheet();
          } else {
            this.getCombinationAnswerSheet();
          }
        }
      },
      bindClass(type, correct, answer) {
        let correctList = correct.split("");
        let answerList = answer.split("");
        let arr = correctList.filter((item) => {
          return answerList.includes(item);
        });
        if (arr.includes(type)) {
          return "green";
        } else {
          if (correctList.includes(type)) {
            //漏选
            return "borderGreen";
          }
          if (answerList.includes(type)) {
            //答错
            return "red";
          }
        }
      },
      bindResult(isRight, item, index) {
        if (isRight === 1) return item.type === 8 ? "grey" : "green";
        if (isRight === 0) return "red";
        return "";
        // const isTopic = this.$route.query.name === "topic";
        // const isUnlocked =
        //   this.$route.query.hasOwnProperty("isUnlock") &&
        //   this.$route.query.isUnlock === "true";
        // let resultClass = "";
        // if (isRight === 1) {
        //   resultClass = item.type === 8 ? "grey" : "green";
        // } else if (isRight === 0) {
        //   resultClass = "red";
        // }
        // if (isTopic && !isUnlocked && index >= 5) {
        //   resultClass = "prohibit";
        // }

        // return resultClass;
      },
      autoBlanksTextarea(textarea) {
        textarea.style.height = "auto"; // 设置高度为自动以重新计算高度
        textarea.style.height = "36px"; // 默认设置为初始高度
        if (textarea.scrollHeight > 36) {
          textarea.style.height = textarea.scrollHeight + "px"; // 设置高度为文本内容的高度
        }
        if (textarea.value.trim() === "") {
          textarea.style.height = "36px"; // 如果内容为空，将高度设置为初始高度
        }
      },
      filterType(type) {
        return this.typeData.find((item) => item.dictValue == type).dictLabel;
      },
      getDict() {
        getDicts("cmtt_exam_type").then((res) => {
          this.typeData = res.data;
        });
      },
      submit(item, index) {
        if (item.type == 5) {
          if (
            this.$route.query.name == "groupQuestion" ||
            this.$route.query.name == "testCreation"
          ) {
            let params = {
              questionId: item.id,
              studyPaperId: this.$route.query.studyPaperId,
              result: item.selectedList.join(","),
              majorType: this.majorType,
            };
            addQuestionResult(params).then((res) => {
              if (res.code == 200) {
                item.result = item.selectedList.join(",");
              }
            });
          } else {
            let params = {
              questionId: item.id,
              studyBankId: this.$route.query.studyBankId,
              result: item.selectedList.join(","),
              categoryId: this.$route.query.categoryId,
              majorType: this.majorType,
            };
            addQuestion(params).then((res) => {
              if (res.code == 200) {
                item.result = item.selectedList.join(",");
              }
            });
          }
        }
        if (item.type == 7) {
          if (
            this.$route.query.name == "groupQuestion" ||
            this.$route.query.name == "testCreation"
          ) {
            // 使用map方法提取每个对象的name属性
            let names = item.blanksList.map((item) => item.name);
            // 使用join方法将names数组中的元素用"[$]"连接起来
            let result = names.join("[$]");
            let params = {
              questionId: item.id,
              studyPaperId: this.$route.query.studyPaperId,
              result: result,
              majorType: this.majorType,
            };
            addQuestionResult(params).then((res) => {
              if (res.code == 200) {
                item.result = result;
                this.texthtml = ""; // 清空对应索引的答案
              }
            });
          } else {
            // 使用map方法提取每个对象的name属性
            let names = item.blanksList.map((item) => item.name);
            // 使用join方法将names数组中的元素用"[$]"连接起来
            let result = names.join("[$]");
            let params = {
              questionId: item.id,
              studyBankId: this.$route.query.studyBankId,
              result: result,
              majorType: this.majorType,
            };
            addQuestion(params).then((res) => {
              if (res.code == 200) {
                item.result = result;
                this.texthtml = ""; // 清空对应索引的答案
              }
            });
          }
        }
        if (item.type == 8) {
          if (
            this.$route.query.name == "groupQuestion" ||
            this.$route.query.name == "testCreation"
          ) {
            let params = {
              questionId: item.id,
              studyPaperId: this.$route.query.studyPaperId,
              result: this.texthtml, // 使用对应索引的答案
              majorType: this.majorType,
            };
            addQuestionResult(params).then((res) => {
              if (res.code == 200) {
                item.result = this.texthtml;
              }
            });
          } else {
            let params = {
              questionId: item.id,
              studyBankId: this.$route.query.studyBankId,
              result: this.texthtml, // 使用对应索引的答案
              majorType: this.majorType,
            };
            addQuestion(params).then((res) => {
              if (res.code == 200) {
                item.result = this.texthtml;
              }
            });
          }
        }
      },
      handleSelect(item, itm, index) {
        console.log("item, itm", item, itm);
        if (item.type == 5) {
          this.$set(itm, "selected", !itm.selected);
          item.selectedList = item.selectList
            .filter((e) => {
              return e.selected;
            })
            .map((e) => e.type);
        } else {
          item.result = itm.type;
          if (
            this.$route.query.name == "groupQuestion" ||
            this.$route.query.name == "testCreation"
          ) {
            let params = {
              questionId: item.id,
              studyPaperId: this.$route.query.studyPaperId,
              result: item.result,
              majorType: this.majorType,
            };
            addQuestionResult(params).then((res) => {});
          } else {
            let params = {
              questionId: item.id,
              studyBankId: this.$route.query.studyBankId,
              result: item.result,
              categoryId: this.$route.query.categoryId,
              majorType: this.majorType,
            };
            addQuestion(params).then((res) => {});
          }
        }
      },
      // 获取答题卡
      async getAnswerSheet() {
        console.log("----------");
        let categoryIdList = null;
        let setList = {}; // 在这里定义 setList
        // 刷题
        if (this.$route.query.name == "topic") {
          // categoryIdList = [this.$route.query.categoryId];
          setList = {
            categoryId: this.$route.query.categoryId,
            //   studyBankId: this.$route.query.studyBankId,
            majorType: this.majorType,
          };
        }
        // 错题
        else if (this.$route.query.name == "errorCorrection") {
          categoryIdList = JSON.parse(this.$route.query.categoryIds);
          setList = {
            categoryIds: categoryIdList,
            // studyBankId: this.$route.query.studyBankId,
            type: 1,
            majorType: this.majorType,
          };
        }
        // // 收藏
        // else {
        //   categoryIdList = JSON.parse(this.$route.query.categoryIds);
        //   setList = {
        //     categoryIds: categoryIdList,
        //     studyBankId: this.$route.query.studyBankId,
        //     isFavorite: 1,
        //   };
        // }
        if (this.$route.query.name == "errorCorrection") {
          const { data } = await wrongAnswerSheett(setList);
          this.answerSheetList = data;
          this.interceptList = [this.answerSheetList[this.topicIndex].questionId];
          this.getQuestionsList();
        } else if (this.$route.query.name == "collect") {
          const { data } = await resourceAnswerSheet(setList);
          this.answerSheetList = data;
          this.interceptList = [this.answerSheetList[this.topicIndex].questionId];
          this.getQuestionsList();
        } else {
          const { data } = await answerSheet(setList);
          this.answerSheetList = data;
          this.interceptList = [this.answerSheetList[this.topicIndex].questionId];
          this.getQuestionsList();
        }
      },
      // 获取收藏答题卡
      async getResourceAnswerSheet() {
        const categoryIdList = JSON.parse(this.$route.query.categoryIds);
        console.log("categoryIdList", categoryIdList);
        const setList = {
          categoryIds: categoryIdList,
          majorType: this.majorType,
        };
        const { data } = await resourceAnswerSheet(setList);
        this.answerSheetList = data;
        this.interceptList = [this.answerSheetList[this.topicIndex].questionId];
        this.getQuestionsList();
      },
      // 获取智能组题答题卡
      async getCombinationAnswerSheet() {
        const { data } = await combinationAnswerSheet(
          this.$route.query.studyPaperId
        );
        this.answerSheetList = data;
        this.interceptList = [this.answerSheetList[this.topicIndex].questionId];
        this.studyPaperGetByIdList();
        this.fiveTypeFlag = true;
      },
      // 滑动
      handleTouchStart(e) {
        this.startX = e.touches[0].clientX;
        this.startY = e.touches[0].clientY;
      },
      handleTouchEnd(e) {
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;

        const diffX = this.startX - endX;
        const diffY = this.startY - endY;

        if (Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX > 0) {
            console.log("-----", this.isUnlock, this.topicIndex);
            // const blockRightSwipe =
            //   this.$route.query.isUnlock === "false" && this.topicIndex === 4;
            // console.log("blockRightSwipe", blockRightSwipe);
            // 左滑
            if (this.topicIndex < this.answerSheetList.length - 1) {
              this.topicIndex++;
              this.resetAudio(); // 重置音频
              this.interceptList = [
                this.answerSheetList[this.topicIndex].questionId,
              ];
              this.texthtml = "";
              if (
                this.$route.query.name == "groupQuestion" ||
                this.$route.query.name == "testCreation"
              ) {
                this.studyPaperGetByIdList();
              } else {
                this.getQuestionsList();
              }
            }
            // else {
            //   this.androidIos();
            // }
          } else {
            // 右滑
            if (this.topicIndex > 0) {
              this.topicIndex--;
              this.resetAudio(); // 重置音频
              this.interceptList = [
                this.answerSheetList[this.topicIndex].questionId,
              ];
              this.texthtml = "";
              if (
                this.$route.query.name == "groupQuestion" ||
                this.$route.query.name == "testCreation"
              ) {
                this.studyPaperGetByIdList();
              } else {
                this.getQuestionsList();
              }
            }
          }
        }
      },
      // 上一题
      upwardClick() {
        if (this.topicIndex > 0) {
          this.topicIndex--;
          this.interceptList = [this.answerSheetList[this.topicIndex].questionId];
          this.getQuestionsList();
        }
      },
      // 下一题
      downClick() {
        if (this.topicIndex < this.answerSheetList.length - 1) {
          this.topicIndex++;
          this.interceptList = [this.answerSheetList[this.topicIndex].questionId];
          this.getQuestionsList();
        }
      },
      // 刷题列表
      async getQuestionsList() {
        let categoryIdList = null;
        let typeFlag = null;
        // 刷题
        if (this.$route.query.name == "topic") {
          categoryIdList = [this.$route.query.categoryId];
          typeFlag = 2;
        }
        // 错题
        else if (this.$route.query.name == "errorCorrection") {
          categoryIdList = JSON.parse(this.$route.query.categoryIds);
          typeFlag = 1;
        }
        // 收藏
        else {
          categoryIdList = JSON.parse(this.$route.query.categoryIds);
          typeFlag = 0;
        }
        const setList = {
          categoryIds: categoryIdList,
          questionIds: this.interceptList,
          // studyBankId: this.$route.query.studyBankId,
          type: typeFlag,
          majorType: this.majorType,
        };
        let data = null;
        if (this.$route.query.name == "topic") {
          const response = await getQuestions(setList);
          data = response.data;
        } else if (this.$route.query.name == "errorCorrection") {
          const response = await getWrongAnswerQuestions(setList);
          console.log("response", response);
          data = response.data;
        } else if (this.$route.query.name == "collect") {
          const response = await getQuestionsList(setList);
          data = response.data;
        }
        this.homeworkList = data
          .map((item) => {
            if (item.type == 7) {
              if (item.result) {
                // this.isTextareaReadOnly = true;
                const blanksContent = item.result
                  .split("[$]")
                  .map((item) => ({ name: item }));
                const correctContent = item.correct.split("[$]");
                item = {
                  ...item,
                  blanksList: blanksContent,
                  correctList: correctContent,
                };
              } else {
                // this.isTextareaReadOnly = false;
                const blanksContent = item.correct
                  .split("[$]")
                  .map((item) => ({ name: "" }));
                const correctContent = item.correct.split("[$]");
                item = {
                  ...item,
                  blanksList: blanksContent,
                  correctList: correctContent,
                };
              }
              return item;
            } else {
              if (item.childedList) {
                return item.childedList.map((child) => {
                  return {
                    publicContent: item.content,
                    ...child,
                    type: item.type,
                  };
                });
              } else {
                return item;
              }
            }
          })
          .flat();
        console.log("this.homeworkList", this.homeworkList);
      },
      // 笔记
      async getOneQuestionIdList(majorType, questionId) {
        this.setUpType = 2;
        const { data } = await getOneQuestionId(majorType, questionId);
        let dataList = [];
        dataList.push(data);
        this.homeworkList = dataList
          .map((item) => {
            if (item.type == 7) {
              if (item.result) {
                this.isTextareaReadOnly = true;
                const blanksContent = item.result
                  .split("[$]")
                  .map((part) => ({ name: part }));
                const correctContent = item.correct.split("[$]");
                item = {
                  ...item,
                  blanksList: blanksContent,
                  correctList: correctContent,
                };
              } else {
                this.isTextareaReadOnly = false;
                const blanksContent = item.correct
                  .split("[$]")
                  .map((part) => ({ name: "" }));
                const correctContent = item.correct.split("[$]");
                item = {
                  ...item,
                  blanksList: blanksContent,
                  correctList: correctContent,
                };
              }
              return item;
            } else {
              if (item.childedList) {
                return item.childedList.map((child) => ({
                  publicContent: item.content,
                  ...child,
                  type: item.type,
                }));
              } else {
                return item;
              }
            }
          })
          .flat();
      },

      // 智能组题
      async studyPaperGetByIdList() {
        const setList = {
          questionIds: this.interceptList.join(","),
        };
        const { data } = await studyPaperGetById(
          this.$route.query.studyPaperId,
          setList
        );
        this.homeworkList = data.questions
          .map((item) => {
            if (item.type == 7) {
              if (item.result) {
                this.isTextareaReadOnly = true;
                const blanksContent = item.result
                  .split("[$]")
                  .map((item) => ({ name: item }));
                const correctContent = item.correct.split("[$]");
                item = {
                  ...item,
                  blanksList: blanksContent,
                  correctList: correctContent,
                };
              } else {
                this.isTextareaReadOnly = false;
                const blanksContent = item.correct
                  .split("[$]")
                  .map((item) => ({ name: "" }));
                const correctContent = item.correct.split("[$]");
                item = {
                  ...item,
                  blanksList: blanksContent,
                  correctList: correctContent,
                };
              }
              return item;
            } else {
              if (item.childedList) {
                return item.childedList.map((child) => {
                  return {
                    publicContent: item.content,
                    ...child,
                    type: item.type,
                  };
                });
              } else {
                return item;
              }
            }
          })
          .flat();
      },
      focus() {
        console.log("focus");
        // this.scroll.disable()
      },
      blur() {
        console.log("blur");
        this.scroll.enable();
      },
      preventTouchMove(event) {
        if (this.cardFlag) {
          event.preventDefault();
        }
      },
      cardBlank() {
        this.toggleCard();
        this.scroll.enable();
      },
      toggleCard() {
        this.cardBoxFlag = false;
        setTimeout(() => {
          this.cardFlag = this.cardBoxFlag;
          this.scroll.enable();
        }, 500);
        //
      },
      // 点击答题卡
      cardLiClick(item, index) {
        // const isTopic = this.$route.query.name === "topic";
        // const isUnlocked =
        //   this.$route.query.hasOwnProperty("isUnlock") &&
        //   this.$route.query.isUnlock === "true";
        // if (isTopic && !isUnlocked && index >= 5) {
        //   this.androidIos();
        //   return;
        // }
        this.topicIndex = index;
        this.cardFlag = false;
        this.interceptList = [item.questionId];
        if (
          this.$route.query.name === "groupQuestion" ||
          this.$route.query.name === "testCreation"
        ) {
          this.studyPaperGetByIdList();
        } else {
          this.getQuestionsList();
        }
      },
      // 收藏
      handleImageClick() {
        console.log("this.homeworkList", this.homeworkList);
        this.setUpFlag = false;
        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout);
        }
        this.debounceTimeout = setTimeout(() => {
          let isFavoriteFlag = this.homeworkList[0].isFavorite === 0 ? 1 : 0;
          const setList = {
            categoryId: this.$route.query.categoryId,
            questionId: this.homeworkList[0].id,
            isFavorite: isFavoriteFlag,
            type: 0,
            majorType: this.majorType,
          };

          addQuestionResource(setList).then((res) => {
            if (res.code === 200) {
              this.collect();
            }
          });

          this.debounceTimeout = null;
        }, 500); // 设置 1 秒的延迟时间
      },

      collect() {
        if (this.currentQuestion.isFavorite === 0) {
          // 使用 currentQuestion
          console.log("已收藏");
          this.collectType = 1;
        } else {
          console.log("取消收藏");
          this.collectType = 0;
        }

        this.currentQuestion.isFavorite =
          this.currentQuestion.isFavorite === 0 ? 1 : 0; // 使用 currentQuestion

        setTimeout(() => {
          this.collectType = 3;
        }, 1000);
      },
      noteClick() {
        this.setUpFlag = false;
        this.noteFlag = true;
      },
      noteSave() {
        const setList = {
          categoryId: this.$route.query.categoryId,
          questionId: this.homeworkList[0].id,
          mark: this.homeworkList[0].mark,
          type: 1,
          majorType: this.majorType,
        };
        addQuestionResource(setList).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.noteFlag = false;
            this.noteType = true;
            setTimeout(() => {
              this.noteType = false;
            }, 1000);
          }
        });
      },
      setUpTypeClick() {
        this.setUpType = this.setUpType === 1 ? 2 : 1;
      },
      // 设置
      closeSetUp() {
        this.setUpFlag = false;
      },
      setUpClick() {
        this.setUpFlag = !this.setUpFlag;
      },
      fontClick(index) {
        this.fontActive = index;
        if (index == 0) {
          this.oneSize = 10;
          this.twoSize = 12;
          this.threeSize = 14;
        } else if (index == 1) {
          this.oneSize = 12;
          this.twoSize = 14;
          this.threeSize = 16;
        } else {
          this.oneSize = 14;
          this.twoSize = 16;
          this.threeSize = 18;
        }
      },
      // 知识库
      knowledgeClick() {
        // const isTopic = this.$route.query.name === "topic";
        // const isUnlocked =
        //   this.$route.query.hasOwnProperty("isUnlock") &&
        //   this.$route.query.isUnlock === "true";
        // if (isTopic && !isUnlocked) {
        //   return;
        // } else {
        this.tabFlag = 0;
        this.setUpFlag = false;
        this.androidIos();
        // }
      },
      // 纠错
      errorCorrectionClick() {
        this.tabFlag = 1;
        this.setUpFlag = false;
        // this.androidIos();
        this.showErrorPopup = true;
        this.fileList = [];
        if (localStorage.getItem("source")) {
          this.isAndroid = false;
          //小程序
        } else {
          if (this.judgeClient() == "Android") {
            this.isAndroid = true;
          } else {
            this.isAndroid = false;
          }
        }
      },
      //安卓上传图片
      uploadAndroid() {
        this.$bridge.callmethod(
          "WebAction.openGetPhoto",
          { ceshi: "ceshi" },
          (res) => {}
        );
        //h5暴露方法给安卓调用，回传值给h5
        let that = this;
        this.$bridge.registermethod("getLocalPhoto", (data) => {
          if (data) {
            that.fileList = [data];
          }
        });
      },
      //微信小程序上传图片
      uploadWeXin() {
        //暂时先不做，目前还没有嵌套小程序方面的业务
        wx.chooseImage({
          count: 3, // 默认9
          sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            console.log(res);
          },
        });
      },
      getApp() {
        axios
          .get(
            "https://www.medmeta.com/api/wechat/wx/jsapi/wx73d5eb8e6d65981e/getJsapiTicket"
          )
          .then((res) => {
            if (res != null) {
              let that = this;
              let url = window.location.href;
              url = url.split("#")[0];
              let tick = res.data;
              let time = parseInt(new Date().getTime() / 1000);
              let nums = this.suijione(true, true, false, 16);
              let str =
                "jsapi_ticket=" +
                tick +
                "&noncestr=" +
                nums +
                "&timestamp=" +
                time +
                "&url=" +
                url;
              let signature = CryptoJS.SHA1(str).toString();
              let appid = "wx73d5eb8e6d65981e";
              wx.config({
                debug: false,
                appId: appid, // 此处APPID为公众号的APPID
                timestamp: time,
                nonceStr: nums,
                signature: signature,
                jsApiList: ["chooseImage"], //此处必须填写一个，不为null就行
                openTagList: ["chooseImage"],
              });
              wx.ready(() => {
                wx.checkJsApi({
                  jsApiList: ["chooseImage"], // 校验跳转APP的标签是否可用
                  success: function (res) {},
                  fail: (err) => {},
                });
              });
              wx.error(function (res) {});
            }
          });
      },
      //上传图片
      async afterRead(file) {
        if (this.fileList.length > 2) {
          Toast("最多可上传三张图片");
          return;
        }
        const _file = file.file;
        let formData = new FormData();
        formData.append("file", _file);
        let res = await uploadImg(formData);
        this.fileList.push(res.data.url);
      },
      delImg(index) {
        this.fileList.splice(index, 1);
      },
      //提交纠错
      async commitError() {
        let imageUrl = this.fileList.length > 0 ? this.fileList.join(",") : "";
        let params = {
          bank: this.homeworkList[this.currentPage].bank,
          questionId: this.homeworkList[this.currentPage].id,
          questionErrorType: this.questionErrorType,
          errorDescription: this.errorDescription,
          imageUrl: imageUrl,
        };
        Toast.loading({
          message: "提交中...",
        });
        let res = await questionFeedBackErrorAdd(params);
        Toast("提交成功");
        this.showErrorPopup = false;
      },
      addFocusBorder(event) {
        event.target.classList.add("focused");
        console.log("event", event);
      },
      removeFocusBorder(event) {
        event.target.classList.remove("focused");
      },
      // 格式化时间 (秒 转 分:秒)
      formatTime(seconds) {
        const min = Math.floor(seconds / 60);
        const sec = Math.floor(seconds % 60);
        return `${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
      },
      // 判断是否为图片文件
      isImgFile(url) {
        return url ? /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(url) : false;
      },
      // 判断是否为音频文件
      isAudioFile(url) {
        return url ? /\.(mp3|wav|ogg|m4a|flac)$/i.test(url) : false;
      },
      // 判断是否为视频文件
      isVideoFile(url) {
        return url ? /\.(mp4|webm|avi|mov|mkv)$/i.test(url) : false;
      },
      // 获取音频总时长
      setDuration(event) {
        this.duration = event.target.duration;
      },
      // 实时更新当前播放时间
      updateCurrentTime(event) {
        if (!this._raf) {
          this._raf = requestAnimationFrame(() => {
            this.currentTime = event.target.currentTime;
            this._raf = null;
            console.log("this.currentTime", this.currentTime);
            console.log("this.duration", this.duration);
          });
        }
      },

      // 播放/暂停音频
      togglePlay() {
        this.$nextTick(() => {
          const audio = this.$refs.audioPlayer[0];
          // console.log('audio',audio)
          if (this.isPlaying) {
            audio.pause();
          } else {
            if (this.currentTime >= this.duration) {
              // 如果播放结束，从头开始播放
              this.currentTime = 0;
              audio.currentTime = 0;
            }
            audio.play();
          }
          this.isPlaying = !this.isPlaying;
        });
      },
      // // 音频播放结束时触发
      onAudioEnded() {
        this.isPlaying = false;
      },

      // 拖动进度条时调整音频播放时间
      onSliderChange(event) {
        const newTime = Number(event.target.value);
        this.currentTime = newTime;

        // 更新音频播放进度
        if (this.$refs.audioPlayer && this.$refs.audioPlayer[0]) {
          this.$refs.audioPlayer[0].currentTime = newTime;
        }
      },
      // **重置音频播放**
      resetAudio() {
        this.currentTime = 0;
        this.isPlaying = false;
        if (this.$refs.audioPlayer && this.$refs.audioPlayer[0]) {
          const audio = this.$refs.audioPlayer[0];
          audio.pause(); // 停止播放
          audio.currentTime = 0; // 进度归 0
        }
      },
    },
};
</script>

<style lang="scss" scoped>
.notBox {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(225deg, #cbeaff 0%, #d9e2ff 100%);

  .loadingCircle {
    position: relative;
    width: 300px;
    height: 300px;
    .circle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background-color: #a8dafc;
      animation: pulse 2s infinite;
    }
    .loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 171px;
      height: 200px;
    }
  }
  span {
    margin-top: 99px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #0a1f33;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }

  @keyframes pulse {
    0% {
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      width: 300px;
      height: 300px;
      opacity: 0;
    }
  }

  .circle:nth-child(2) {
    animation-delay: 0.5s;
  }

  .circle:nth-child(3) {
    animation-delay: 1s;
  }
}
.wrapper {
  width: 100%;
  height: 100vh;
  .head {
    padding: 44px 16px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .titleLeft {
      display: flex;
      // width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      img {
        width: 20px;
        height: 20px;
      }
      .label {
        font-weight: 600;
        font-size: 16px;
      }
    }
    .titleRight {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // max-width: 149px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      // border-radius: 50%;
      // background: rgba(27, 191, 141, 0.1);
      div {
        margin-right: 10px;
        width: 28px;
        height: 28px;
      }
      img {
        margin-right: 10px;
        width: 28px;
        height: 28px;
        line-height: 28px;
        &:last-child {
          margin-right: 6px;
        }
      }
    }
  }
  #contain {
    width: 100vw;
    height: calc(100vh - 88px);
    overflow: hidden;
    .homework {
      height: 100%; // 修改：移除固定高度
      // display: flex; // 修改：移除 flex 布局
      li {
        list-style: none;
        height: 100%;
        width: 100%; // 修改：修改宽度为 100%
        // flex-shrink: 0; // 修改：移除 flex-shrink
        font-size: 16px;
        &.homeLi {
          padding: 12px 16px;
          display: flex;
          flex-direction: column;
          overflow-x: hidden;

          .homework-main {
            flex: 1;
            overflow-y: scroll;
            &::-webkit-scrollbar {
              display: none;
            }
            &.active {
              display: flex;
              flex-direction: column;
              .title {
              }
            }
          }
        }
        .title {
          // display: flex;
          // justify-content: center;
          // align-items: center;
          padding: 5px;
          height: 18px;
          line-height: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #00ad78;
          background: rgba(27, 191, 141, 0.16);
        }
        .publicContent {
          margin-top: 10px;
          line-height: 24px;
          font-size: 14px;
        }
        .content {
          font-family: PingFangSC, PingFang SC;
          margin-top: 10px;
          font-weight: 500;
          line-height: 30px;
          color: #000;
        }
        .file {
          display: flex;
          justify-content: center;
          width: 100%;
          .imgBox {
            width: 300px;
            height: 200px;
            background: #d8d8d8;
            border-radius: 10px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover; /* 等比例裁剪填充 */
            }
          }
          .videoBox {
            width: 300px;
            height: 200px;
            background: #d8d8d8;
            border-radius: 10px;
            overflow: hidden;
          }
          .audioBox {
            width: 310px;
            height: 106px;
            .progressBar {
              display: flex;
              align-items: center;
              gap: 10px;
              margin-bottom: 14px;
              width: 100%;
              height: 20px;
              input[type="range"] {
                width: 212px;
                height: 6px;
                background: #f2f8f5;
                border-radius: 3px;
                border: none; /* 去掉边框 */
                outline: none; /* 去掉选中时的外边框 */
                -webkit-appearance: none; /* 去掉默认样式（适用于 WebKit 浏览器，如 Chrome、Safari） */
              }
              /* 自定义滑块轨道样式 */
              input[type="range"]::-webkit-slider-runnable-track {
                width: 100%;
                height: 6px;
                // background: #1bbf8d;
                border-radius: 3px;
              }

              /* 自定义滑块按钮样式 */
              input[type="range"]::-webkit-slider-thumb {
                -webkit-appearance: none;
                width: 10px;
                height: 10px;
                background: #1bbf8d;
                border-radius: 50%;
                cursor: pointer;
                margin-top: -2px; /* 让滑块和轨道对齐 */
                box-shadow: 0 0 0 5px rgba(27, 191, 141, 0.1);
              }
              // /* 兼容 Firefox */
              // input[type="range"]::-moz-range-progress {
              //   background: #1bbf8d;
              // }
              // input[type="range"]::-moz-range-track {
              //   background: #f2f8f5;
              // }
            }
            .operateBox {
              position: relative;
              padding: 0 35px;
              width: 100%;
              height: 72px;
              .wave {
                position: absolute;
                top: 50%;
                width: 218px;
                height: 24px;
                transform: translateY(-50%);
                background-image: url("../../assets/images/wave.png");
                background-size: cover; /* 让背景图完全覆盖 */
                background-position: center; /* 让背景图居中 */
                background-repeat: no-repeat; /* 防止背景重复 */
              }
              .pause {
                position: absolute;
                left: 50%;
                transform: translateX(-60%);
                width: 72px;
                height: 72px;
                background-image: url("../../assets/images/pause.png");
                background-size: cover; /* 让背景图完全覆盖 */
                background-position: center; /* 让背景图居中 */
                background-repeat: no-repeat; /* 防止背景重复 */
              }
              .play {
                position: absolute;
                left: 50%;
                transform: translateX(-60%);
                width: 72px;
                height: 72px;
                background-image: url("../../assets/images/play.png");
                background-size: cover; /* 让背景图完全覆盖 */
                background-position: center; /* 让背景图居中 */
                background-repeat: no-repeat; /* 防止背景重复 */
              }
            }
          }
        }
        .publicSelect {
          li {
            display: flex;
            align-items: center;
            padding: 5px 0;
            width: calc(100vw - 32px);
          }
        }
        .select {
          li {
            display: flex;
            align-items: center;
            padding: 13px 0;
            width: 100%;
          }
          span {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 0 0 28px;
            width: 28px;
            height: 28px;
            border: 1px solid #dddddd;
            border-radius: 50%;
            color: #7f8d95;
            margin-right: 12px;
            &.selected {
              background: #1bbf8d;
              color: #fff;
            }
            &.borderGreen {
              border-color: #1bbf8d;
              color: #1bbf8d;
            }
            &.red {
              background: #fe4e27;
              color: #fff;
            }
            &.green {
              background: #1bbf8d;
              color: #fff;
            }
            &.grey {
              background: grey;
              color: #fff;
            }
          }
        }
        .blanksUl {
          padding: 0;
          margin-top: 24px;
          width: 100%;
          li {
            margin-bottom: 12px;
            width: 100%;
            list-style: none;
            textarea {
              padding: 9px 10px;
              width: 100%;
              height: 40px;
              // line-height: 36px;
              background: #f5f5f5;
              border-radius: 8px;
              font-size: 16px;
              outline: none; // 如何把蓝色去掉？
              border: 1px solid #f5f5f5; /* 初始化边框颜色为灰色 */
              resize: none; /* 禁止手动调整大小 */
              overflow-y: hidden; /* 隐藏垂直滚动条 */
              box-sizing: border-box; /* 防止padding和border增加实际宽度 */
            }
            textarea:focus {
              outline: none; // 如何把蓝色去掉？
              border: 1px solid #58b195; // 如何改成别的颜色？
            }

            // .focus-border {
            //   border-color: #58b195;
            // }
            // .focus-border {
            //   padding: 9px 10px;
            //   width: 100%;
            //   // height: 40px;
            //   background: #f5f5f5;
            //   border-radius: 8px;
            //   font-size: 16px;
            //   // outline: none; // 如何把蓝色去掉？
            //   border: 1px solid #f5f5f5; /* 初始化边框颜色为灰色 */
            //   resize: none; /* 禁止手动调整大小 */
            //   // overflow-y: hidden; /* 隐藏垂直滚动条 */
            //   box-sizing: border-box; /* 防止padding和border增加实际宽度 */
            //   &.focus-border {
            //     border-color: #58b195;
            //   }
            // }
          }
        }
        .correctAnswerBox {
          margin-top: 20px;
          .correctAnswer {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #222222;
            height: 24px;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            span {
              margin-right: 5px;
              width: 3px;
              height: 14px;
              background: #1bbf8d;
            }
          }
          .selectAnswer {
            font-size: 16px;
            margin-bottom: 24px;
            span {
              color: #1bbf8d;
            }
          }
          .correct {
            line-height: 28px;
            text-align: left;
          }
        }
        .correctAnswerUl {
          margin-top: 10px;
          .correctAnswerLi {
            margin-bottom: 4px;
            list-style: none;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }
        .upwardBtn {
          width: 100px;
          height: 100px;
        }
        .downBtn {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
  .askInput {
    border: 1px solid #dddddd;
    width: 100%;
    min-height: 100%;
    // height: auto;
    margin-top: 12px;
    margin-bottom: 20px;
    padding: 10px;
    // overflow: hidden;
    resize: none;
    // overscroll-behavior: contain;
  }
  .haveResult {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 10px;
  }

  .bottom {
    height: 86px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .btn {
      padding: 0px 24px;
      height: 48px;
      line-height: 48px;
      background: #1bbf8d;
      box-shadow: 0px 3px 10px 0px rgba(27, 191, 141, 0.3);
      border-radius: 24px;
      color: #fff;
      text-align: center;
      font-size: 16px;
      display: inline-block;
    }
  }
}

@keyframes cardUp {
  from {
    transform: translateY(100%); /* 从元素上方滑入 */
    opacity: 0; /* 初始透明度为0 */
  }
  to {
    transform: translateY(0);
    opacity: 1; /* 结束时完全不透明 */
  }
}
@keyframes cardDown {
  from {
    transform: translateY(0); /* 从元素上方滑入 */
    opacity: 1; /* 初始透明度为0 */
  }
  to {
    transform: translateY(100%);
    opacity: 0; /* 结束时完全不透明 */
  }
}

.card {
  padding: 8px 21px;
  position: absolute;
  bottom: 0; /* 初始状态在底部之外 */
  width: 100%;
  height: 50%;
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;


  .cardTitle {
    margin-top: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #2f2f46;
    text-align: center;
    font-style: normal;
  }
  .cardUl {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 0px 5px; /* 添加间距 */
    width: 100%;
    max-height: 60%;
    transition: max-height 0.5s ease-in-out;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    li {
      margin-bottom: 10px;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #ffffff;
      border: 1px solid #dddddd;
      list-style: none;
      font-family: ArialMT;
      font-size: 13px;
      color: #8b949a;
      line-height: 28px;
      text-align: center;
      font-style: normal;
      &.red {
        background: #fe4e27;
        color: #fff;
      }
      &.green {
        background: #1bbf8d;
        color: #fff;
      }
      &.grey {
        background: grey;
        color: #fff;
      }
      &.prohibit {
        color: #cdd2d5;
      }
    }
    .active {
      background: #1bbf8d;
      color: #ffffff;
    }
  }
  .bottom {
    position: absolute;
    bottom: 0px;
    width: calc(100% - 42px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.errorCon {
  height: calc(100% - 45px);
  .top {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    .type {
      display: inline-block;
      padding: 5px 10px;
      font-size: 15px;
      color: #666666;
      background: #e8e8e8;
      border-radius: 5px;
    }
    .activeType {
      background: #1bbf8d;
      color: #ffffff;
    }
  }
  .errorValue {
    margin-top: 10px;
    border: 1px solid #e8e8e8;
    height: 80%;
    border-radius: 8px;
    overflow: hidden;
    .imgCon {
      padding: 10px;
      display: flex;
      .imgContent {
        display: flex;
        justify-content: space-around;
        .pos {
          position: relative;
          .delImg {
            position: absolute;
            right: 0;
            top: -10px;
          }
          .sizeImg {
            margin-right: 10px;
            width: 80px;
            height: 80px;
          }
        }
      }
      .photo {
        width: 80px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        border: 1px solid #e8e8e8;
        .photo-o {
          vertical-align: middle;
        }
      }
    }
  }
  .btn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #666666;
    background: #e8e8e8;
    border-radius: 18px;
    margin: 10px auto;
  }
}
.collect {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 36px;
  background: rgba(51, 51, 51, 0.8);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  font-style: normal;
}
.cancelCollect {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 92px;
  height: 36px;
  background: rgba(51, 51, 51, 0.8);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  font-style: normal;
}

.noteBox {
  padding: 30px 16px 15px 16px;
  width: 100%;
  height: 80%;
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
  backdrop-filter: blur(6px);
  .errorCon{
    height: calc(100% - 45px);
    .top{
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      .type{
        display: inline-block;
        padding: 5px 10px;
        font-size: 15px;
        color: #666666;
        background: #e8e8e8;
        border-radius: 5px;
      }
      .activeType{
        background: #1bbf8d;
        color: #FFFFFF;
      }
    }
    .errorValue{
      margin-top: 10px;
      border: 1px solid #e8e8e8;
      height: 80%;
      border-radius: 8px;
      overflow: hidden;
      .imgCon{
        padding: 10px;
        display: flex;
        .imgContent{
          display: flex;
          justify-content: space-around;
          .pos{
            position: relative;
            .delImg{
              position: absolute;
              right: 0;
              top: -10px;
            }
            .sizeImg{
              margin-right: 10px;
              width: 80px;
              height: 80px;
            }
          }

        }
        .photo{
          width: 80px;
          height: 80px;
          text-align: center;
          line-height: 80px;
          border: 1px solid #e8e8e8;
          .photo-o{
            vertical-align: middle;
          }
        }
      }
    }
    .btn{
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #666666;
      background: #e8e8e8;
      border-radius: 18px;
      margin: 10px auto;
    }
  }
  h2 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #2f2f46;
    // line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .noteTextarea {
    margin-top: 16px;
    padding: 10px 16px;
    width: 100%;
    height: 352px;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    border-radius: 12px;
    border: 1px solid #eeeeee;
    background: #ffffff;
    overflow-x: hidden;
    overflow-y: scroll; /* 允许Y轴滚动 */
    // textarea {
    //   width: 100%; /* 确保textarea宽度自适应 */
    //   height: 100%; /* 高度自适应 */
    //   overflow-x: hidden; /* 隐藏X轴滚动条 */
    //   overflow-y: scroll; /* 允许Y轴滚动 */
    //   resize: none; /* 禁止手动调整大小 */
    //   box-sizing: border-box; /* 包含内边距和边框在内 */
    //   white-space: pre-wrap; /* 确保换行 */
    //   word-wrap: break-word; /* 遇到长单词换行 */
    // }
  }
  textarea:focus {
    outline: none; // 如何把蓝色去掉？
    border: 1px solid #58b195; // 如何改成别的颜色？
  }
  .noteBtnBox {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    width: 100%;
    .noteBtn {
      width: 140px;
      height: 48px;
      background: #1bbf8d;
      border-radius: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 48px;
      text-align: center;
      font-style: normal;
    }
  }
}
.setUpBox {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 92px;
  right: 10px;
  width: 150px;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(188, 190, 192, 0.4);
  border-radius: 8px;
  .setUpType {
    display: flex;
    padding: 2px;
    width: 100px;
    height: 28px;
    background: #f3f3f3;
    border-radius: 14px;
    div {
      width: 48px;
      height: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #bbbbbb;
      line-height: 24px;
      text-align: center;
      font-style: normal;
    }
    .active {
      background: #ffffff;
      border-radius: 12px;
      opacity: 1;
      color: #000;
    }
    .setUpType div:not(.active) {
      opacity: 0;
    }
  }
  .setUpFont {
    padding: 0 29px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #bbbbbb;
    text-align: left;
    font-style: normal;
    .active {
      color: #333333;
    }
    span:first-child {
      font-size: 14px;
    }
    span:nth-child(2) {
      font-size: 16px;
    }
    span:last-child {
      font-size: 20px;
    }
  }
}
</style>

